import { Link } from "react-router-dom";

export const Logo = ({ to = "/", sub = "Courtside by HoopsHQ", size = "h-9" }) => (
  <Link to={to} data-testid="brand-logo-link" className="group flex items-center gap-3">
    <img src="/logo-mark.png" alt="GAMEDAY" className={`${size} w-auto transition-transform duration-500 group-hover:rotate-[60deg]`} />
    <span className="flex flex-col leading-none">
      <span className="font-display text-xl font-extrabold tracking-wide text-white">
        GAME<span className="text-[#FF3B30]">DAY</span>
      </span>
      {sub && <span className="font-mono-gd text-[10px] uppercase tracking-[0.3em] text-[#39FF14]">{sub}</span>}
    </span>
  </Link>
);
